import classNames from 'classnames';
import { ContentBlock, FlexContainer, Icon, Txt } from 'components';
import styles from './CauseItem.module.scss';

/**
 * CauseItem
 *
 * @return {JSX.Element}
 */
const CauseItem = ({ className, value, index, onDelete, onEdit }) => {
  return (
    <ContentBlock
      className={classNames(styles.CauseItem, className, CauseItem.displayName)}
      gap
      alignCenter
      spaceBetween
    >
      <FlexContainer column gapQuad>
        <Txt caption>{`Clause ${index}`}</Txt>
        <Txt regular>{value}</Txt>
      </FlexContainer>
      {onDelete || onEdit ? (
        <FlexContainer alignCenter className={styles.ActionPanel} gapQuad>
          {onEdit ? <Icon name="edit" onClick={onEdit} /> : null}
          {onDelete ? (
            <Icon onClick={onDelete} name="close" highlight="black" />
          ) : null}
        </FlexContainer>
      ) : null}
    </ContentBlock>
  );
};

CauseItem.displayName = 'CauseItem';

export default CauseItem;
